var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke":"#055A7F","stroke-width":"2"}},[_c('path',{attrs:{"d":"M2.792 3.918h8.25M2.792 12.126h8.25M5.792 8.126h8.25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }